import './styles.scoped.css';
import { Helmet } from 'react-helmet-async';
import { Row } from 'react-bootstrap';
//import CookiesForm from '../../components/CookiesForm/CookiesForm';

interface ContentProps {
};

const Regulamin: React.FC<ContentProps> = ({}) => {
    return (
      <main className='content'>
        <Helmet>
          <title>Regulamin koła - Teambit</title>
        </Helmet>
        {/* <CookiesForm/> */}
        <div className='regulations'>
            <Row className='backg backg1'/>
            <Row className='backg backg2'/>
            <Row className='backg backg3'/>
            <Row className='backg backg4'/>
            <Row className='backg backg5'/>
            <Row className='backg backg6'/>
            <Row className='backg backg7'/>
            <Row className='backg backg8'/>
            <Row className='backg backg9'/>
            <Row className='backg backg10'/>
            <Row className='backg backg11'/>
            <Row className='backg backg12'/>
            <Row className='backg backg13'/>
            <Row className='backg backg14'/>
          <h1 className='font-italic'>Regulamin Studenckiego koła naukowego „TeamBit” działającego przy Wydziale Informatyki Politechniki Opolskiej</h1>
          <h2>I. CELE I ZADANIA</h2>
          <ol>
            <li>Pogłębianie wiedzy i umiejętności z zakresu programowania (z nastawieniem na programowanie zespołowe) i dziedzin pokrewnych.</li>
            <li>Organizowanie konkursów programowania indywidualnego i programowania zespołowego oraz przygotowanie i wystawianie własnej reprezentacji na takie konkursy.</li>
            <li>Wykonanie projektów indywidualnych i grupowych.</li>
            <li>Współpraca z uczelnią jak również z innymi organizacjami zajmującymi się podobną tematyką.</li>
          </ol>

          <h2>II. ZARZĄD I STRUKTURA KOŁA</h2>
          <ol>
            <li>Członkami koła mogą być wszyscy studenci i pracownicy Politechniki Opolskiej.</li>
            <li>
              Obowiązkami członków koła są:
              <ol type='a'>
                <li>aktywna merytoryczna praca</li>
                <li>pomoc w organizowaniu różnych przedsięwzięć</li>
                <li>uczestnictwo w zebraniach nadzwyczajnych, za wyjątkiem usprawiedliwionych przypadków</li>
                <li>kreowanie pozytywnego wizerunku koła na Uczelni</li>
                <li>uczestniczenie w pracach nad projektami, tj. praca w poszczególnych grupach</li>
              </ol>
            </li>
            <li>
              Aby zostać członkiem koła należy:
              <ol type='a'>
                <li>zapoznać się z niniejszym regulaminem i zobowiązać się do jego przestrzegania</li>
                <li>spełniać wymagania tegoż regulaminu</li>
                <li>wpisać się na listę członków koła</li>
              </ol>
            </li>
            <li>Rażące uchybienia w obowiązkach członka koła mogą, decyzją Zarządu, skutkować usunięciem.</li>
            <li>
              Zarząd Koła tworzą:
              <ol type='a'>
                <li>opiekun naukowy</li>
                <li>przewodniczący</li>
                <li>wiceprzewodniczący</li>
                <li>skarbnik</li>
                <li>sekretarz</li>
              </ol>
            </li>
            <li>
              Obowiązki członków Zarządu koła są:
              <ol type='a'>
                <li>kierowanie funkcjonowaniem koła, tj. organizowanie bieżącej działalności koła</li>
                <li>reprezentowanie koła wobec władz Wydziału i Uczelni, jak również poza Uczelnią</li>
                <li>aktywna praca na rzecz rozwoju koła</li>
                <li>egzekwowanie przestrzegania niniejszego regulaminu przez członków koła</li>
                <li>wypełnianie obowiązków zwykłego członka koła</li>
              </ol>
            </li>
            <li>Rażące uchybienia w obowiązkach członka Zarządu koła mogą, decyzją przewodniczącego, skutkować usunięciem.</li>
            <li>Zarząd koła podejmuje wszelkie decyzje bezwzględną większością głosów, przy obecności co najmniej 1/2 członków Zarządu.</li>
            <li>Zarząd koła wybierany jest na walnym zgromadzeniu bezwzględną większością głosów, przy obecności co najmniej 2/3 członków.</li>
            <li>Kadencja Zarządu trwa jeden rok.</li>
          </ol>

          <h2>III. USTALENIA KOŃCOWE</h2>
          <ol>
            <li>Koło może zostać rozwiązane przez samych członków na wniosek władz uczelni.</li>
            <li>Zmiany w regulaminie i celach działalności koła mogą być wprowadzone po uchwaleniu ich na zebraniu Zarządu większością głosów, przy obecności 2/3 członków Zarządu.</li>
            <li>Członkowie koła spoza Zarządu mogą również składać wnioski o zmiany w regulaminie i celach działalności koła. Wnioski rozpatrywane są na zebraniach Zarządu.</li>
            <li>Swoją działalność koło opiera na bazie lokalowej i technicznej Politechniki Opolskiej.</li>
            <li>
              Środki finansowe koła pochodzą:
              <ol type='a'>
                <li>z dotacji Uczelni</li>
                <li>od sponsorów, tj. firm prywatnych</li>
                <li>z pomocy innych organizacji</li>
              </ol>
            </li>
          </ol>
        </div>
      </main>  
    );
}
export default Regulamin;